import React from 'react';
import style from './style';
import EAIcon from '../../../../components/common/EAIcon';
import clsx from 'clsx';

const CalculatedAttributes = ({attributes, type}) => {
  const { classes } = style();
  const backgroundClass = type === 'indicator' ? classes.indicatorBackground : classes.attributeBackground;
  const icon = type === 'indicator' ? '/context/contextTiers/indicator' : '/context/contextTiers/ctx_attributs';

  return <div className={classes.root}>
    {attributes.map((attr) =>
      <div className={classes.attribute}>
        <div className={clsx(classes.attributeName, backgroundClass)}>
          <EAIcon
            icon={icon}
            className={classes.nameIcon}
          />
          <div>{attr.name}</div>
        </div>
        <div className={classes.attributeValue}>
          {attr.resultValue}
        </div>
      </div>
    )}
  </div>
}

export default CalculatedAttributes;